module.exports = __webpack_public_path__ + "img/cir-bod.a73de788.png";